var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"dashboard"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-3 col-md-4 col-sm-12 col-12"}),_c('div',{staticClass:"col-lg-9 col-md-8 col-sm-12 col-12"},[_c('h1',{domProps:{"textContent":_vm._s(_vm.translate.trans('pinker.titleHomePage'))}})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }